export default "__VITE_ASSET__BJk5OPb6__"